import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import employee from "../assets/images/corporate/employee.jpg";
import leasing from "../assets/images/corporate/leasing.jpg";
import rent from "../assets/images/corporate/rent.jpg";
import trip from "../assets/images/corporate/trip.jpg";
import event from "../assets/images/corporate/event.jpg";
import transport from "../assets/images/corporate/transport.jpg";
import routing from "../assets/images/corporate/routing.jpg";
import reporting from "../assets/images/corporate/reporting.jpg";
import billing from "../assets/images/corporate/billing.jpg";
function Corporate() {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={8} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>CORPORATE Services</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row className="mt-30">
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40" style={{height:"503px"}}>
                <img src={employee} className="img-fluid" alt=""></img>
                <h6>Employee Transportation</h6>
                <p>
                  Whatever may be the employee number; we can arrange you secure
                  transportation facilities. As a dedicated team, we arrange the
                  transports with respect to the passenger numbers in a
                  well-organized way. We not only serve staff but also extend
                  it to guests. A highly comfortable travel for patrons is
                  assured without any complications.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40"  style={{height:"503px"}}>
                <img src={leasing} className="img-fluid" alt=""></img>
                <h6>Executive Leasing</h6>
                <p>
                  We are ready to provide the leased workers for the short-term
                  and long-term agreements especially in the payroll and tax
                  reporting etc. On the other side, we also offer the beneficial
                  way of experimenting the projects without the enhanced
                  responsibility of the human resource management. Our
                  professional team is ready to give the unique tour for the
                  properties to the probable lessees.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40"  style={{height:"503px"}}>
                <img src={rent} className="img-fluid" alt=""></img>
                <h6>Premium Rent a Cab</h6>
                <p>
                All models of Indigo, Honda City, Toyota and Benz cars are available in optimum rate for rent. We provide you with a variety of rental schemes; within the city, out of station and tour packages with and without drivers. Customer satisfaction is our main objective. Charges that we offer are standard to highly feasible.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={trip} className="img-fluid" alt=""></img>
                <h6>Employee Trips</h6>
                <p>
                We also schedule travel plans for official employee trips. Bus, train, flight, and car or any mode of transportation, according to your budget will be well organized. All services are provided in a highly ethical and professional environment. With our expert team, official trips are planned perfectly without any leakage of money.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={event} className="img-fluid" alt=""></img>
                <h6>Events / Seminars</h6>
                <p>
                Are you conducting any corporate event and worried about travel? We help you take your team to the event destination. Even for educational meet-ups like seminars, exceptional on-time transportation of staff is possible. We offer professional service with a keen eye to time management, especially during important business gatherings.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={transport} className="img-fluid" alt=""></img>
                <h6>Transport Desk & Ticketing</h6>
                <p>
                We maintain a transport desk to serve you 24*7. If you have any queries or doubts regarding travel you can feel free to contact us and resolve your issues. Ticketing service is also offered here. Any change with the boarding, changes in ticket plan all labors are skillfully carried out.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={routing} className="img-fluid" alt=""></img>
                <h6>Rostering /Routing</h6>
                <p>
                With the experienced expert team, we not only arrange transport facility but also guide you with nominal routes. Our routing team equipped with navigation systems and live route updates will help you find the ideal route to reach the desired destination in time. The mere rate is charged for planning a perfect route according to the mode of the vehicle. We aid you to choose wisely and save your money.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={reporting} className="img-fluid" alt=""></img>
                <h6>Management Reporting</h6>
                <p>
                Documentation on every trip is prepared and submitted at the management. It is highly useful for official trips. Our documentation comprises an in-depth analysis of the trip. The client can refer the report to get accurate details for the entire travel. We provide a copy if requested which may be used as a record for future references or for any legal requirements.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={billing} className="img-fluid" alt=""></img>
                <h6>Systemized Billing
</h6>
                <p>
                Our billing system is absolutely digitalized; ensuring a fair rate with no additional charges. We are an end to end technology driven company offering a comfortable service to customers. Since the billing is the automated probability of occurrence of an error is almost zero. Our online transaction platform is highly secure and supports all modes of transfer as credit card/debit card and net banking.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Corporate;
